webpackJsonp([137591856104208],{

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Product = exports.productFragments = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(40);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reselect = __webpack_require__(11);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _leftArrow = __webpack_require__(332);
	
	var _leftArrow2 = _interopRequireDefault(_leftArrow);
	
	var _rightArrow = __webpack_require__(333);
	
	var _rightArrow2 = _interopRequireDefault(_rightArrow);
	
	var _productModule = __webpack_require__(249);
	
	var _productModule2 = _interopRequireDefault(_productModule);
	
	__webpack_require__(270);
	
	var _redux2 = __webpack_require__(49);
	
	var _redux3 = __webpack_require__(87);
	
	var _Selector = __webpack_require__(106);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _redux4 = __webpack_require__(19);
	
	var _FAQ = __webpack_require__(42);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var cx = _bind2.default.bind(_productModule2.default);
	var createHandlerMemo = _lodash2.default.memoize(function (value, handler) {
	  return function () {
	    return handler(value);
	  };
	});
	var getCommerceMeta = function getCommerceMeta(_ref) {
	  var images = _ref.data.jamProduct.images;
	  return {
	    image: images.front
	  };
	};
	var getGoCommerceData = function getGoCommerceData(_, _ref2) {
	  var _ref2$data$jamProduct = _ref2.data.jamProduct,
	      sku = _ref2$data$jamProduct.sku,
	      name = _ref2$data$jamProduct.name,
	      prices = _ref2$data$jamProduct.prices,
	      path = _ref2$data$jamProduct.path;
	  return {
	    path: path,
	    prices: prices,
	    sku: sku,
	    title: name,
	    type: 'shoe'
	  };
	};
	
	var mapStateToProps = (0, _reselect.createSelector)(getGoCommerceData, _redux2.currentQuantitySelector, _redux2.currentImageSelector, _redux2.currentSizeSelector, _redux4.itemsMapSelector, _redux3.showProductModalSelector, function (gocommerceData, currentQuantity, currentImage, currentSize, itemsMap, showingProductModal) {
	  return {
	    currentImage: currentImage,
	    currentCartQuantity: (itemsMap[gocommerceData.sku] || {}).quantity,
	    currentQuantity: currentQuantity,
	    gocommerceData: gocommerceData,
	    currentSize: currentSize,
	    isSubmitDisabled: !currentSize,
	    showingProductModal: !!showingProductModal
	  };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  var _props$data$jamProduc = props.data.jamProduct,
	      thumbnails = _props$data$jamProduc.thumbnails,
	      sizes = _props$data$jamProduc.sizes;
	
	
	  var sizeHandlers = (0, _redux.bindActionCreators)(sizes.reduce(function (s, size) {
	    s[size] = createHandlerMemo(size, _redux2.currentSizeChanged);
	    return s;
	  }, {}), dispatch);
	
	  var thumbnailHandlers = (0, _redux.bindActionCreators)(_lodash2.default.reduce(thumbnails, function (s, _, side) {
	    s[side] = createHandlerMemo(side, _redux2.thumbnailClicked);
	    return s;
	  }, {}), dispatch);
	
	  return {
	    dispatch: dispatch,
	    sizeHandlers: sizeHandlers,
	    thumbnailHandlers: thumbnailHandlers,
	    clickOnProductDetails: function clickOnProductDetails() {
	      return dispatch((0, _redux2.clickOnProductDetails)());
	    },
	    quantityChanged: function quantityChanged(x) {
	      return dispatch((0, _redux2.quantityChanged)(x && x.value || undefined));
	    },
	    productMounted: function productMounted(n) {
	      return dispatch((0, _redux2.productMounted)(n));
	    },
	    productChanged: function productChanged(n) {
	      return dispatch((0, _redux2.productChanged)(n));
	    }
	  };
	};
	
	var mergeProps = function mergeProps(stateProps, _ref3, ownProps) {
	  var dispatch = _ref3.dispatch,
	      dispatchProps = _objectWithoutProperties(_ref3, ['dispatch']);
	
	  var gocommerceData = stateProps.gocommerceData;
	
	  var commerceMeta = getCommerceMeta(ownProps);
	  return _extends({}, ownProps, stateProps, dispatchProps, {
	    clickOnAddToCart: function clickOnAddToCart() {
	      return dispatch((0, _redux2.clickOnAddToCart)(_extends({}, gocommerceData, {
	        meta: _extends({}, commerceMeta, {
	          size: stateProps.currentSize
	        }),
	        quantity: stateProps.currentQuantity
	      })));
	    }
	  });
	};
	
	var productFragments = exports.productFragments = '** extracted graphql fragment **';
	
	var propTypes = {
	  clickOnAddToCart: _propTypes2.default.func.isRequired,
	  currentCartQuantity: _propTypes2.default.number,
	  currentQuantity: _propTypes2.default.number,
	  currentImage: _propTypes2.default.string,
	  currentSize: _propTypes2.default.number,
	  data: _propTypes2.default.shape({
	    jamProduct: _propTypes2.default.shape({
	      slug: _propTypes2.default.string,
	      description: _propTypes2.default.string,
	      details: _propTypes2.default.arrayOf(_propTypes2.default.string),
	      images: _propTypes2.default.shape({
	        back: _propTypes2.default.object,
	        front: _propTypes2.default.object,
	        side: _propTypes2.default.object
	      }),
	      name: _propTypes2.default.string,
	      prices: _propTypes2.default.array,
	      sale: _propTypes2.default.string,
	      sizes: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	      thumbnails: _propTypes2.default.shape({
	        back: _propTypes2.default.object,
	        front: _propTypes2.default.object,
	        side: _propTypes2.default.object
	      })
	    }).isRequired
	  }).isRequired,
	  gocommerceData: _propTypes2.default.object,
	  isSubmitDisabled: _propTypes2.default.bool,
	  sizeHandlers: _propTypes2.default.object,
	  thumbnailHandlers: _propTypes2.default.object,
	  quantityChanged: _propTypes2.default.func.isRequired,
	  productMounted: _propTypes2.default.func.isRequired,
	  productChanged: _propTypes2.default.func.isRequired,
	  showBackToShoes: _propTypes2.default.bool,
	  showingProductModal: _propTypes2.default.bool,
	  clickOnProductDetails: _propTypes2.default.func
	};
	
	var Product = exports.Product = function (_PureComponent) {
	  _inherits(Product, _PureComponent);
	
	  function Product() {
	    _classCallCheck(this, Product);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Product.prototype.componentDidMount = function componentDidMount() {
	    this.props.productMounted(this.props.currentCartQuantity);
	  };
	
	  Product.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.gocommerceData.sku !== nextProps.gocommerceData.sku) {
	      this.props.productChanged(nextProps.currentCartQuantity);
	    }
	  };
	
	  Product.prototype.render = function render() {
	    var _props = this.props,
	        clickOnAddToCart = _props.clickOnAddToCart,
	        currentImage = _props.currentImage,
	        currentQuantity = _props.currentQuantity,
	        currentSize = _props.currentSize,
	        _props$data$jamProduc2 = _props.data.jamProduct,
	        description = _props$data$jamProduc2.description,
	        details = _props$data$jamProduc2.details,
	        images = _props$data$jamProduc2.images,
	        name = _props$data$jamProduc2.name,
	        _props$data$jamProduc3 = _props$data$jamProduc2.maxQuantity,
	        maxQuantity = _props$data$jamProduc3 === undefined ? 4 : _props$data$jamProduc3,
	        prices = _props$data$jamProduc2.prices,
	        sale = _props$data$jamProduc2.sale,
	        sizes = _props$data$jamProduc2.sizes,
	        _props$data$jamProduc4 = _props$data$jamProduc2.thumbnails,
	        thumbnails = _props$data$jamProduc4 === undefined ? {} : _props$data$jamProduc4,
	        slug = _props$data$jamProduc2.slug,
	        gocommerceData = _props.gocommerceData,
	        isSubmitDisabled = _props.isSubmitDisabled,
	        sizeHandlers = _props.sizeHandlers,
	        thumbnailHandlers = _props.thumbnailHandlers,
	        quantityChanged = _props.quantityChanged,
	        _props$showBackToShoe = _props.showBackToShoes,
	        showBackToShoes = _props$showBackToShoe === undefined ? true : _props$showBackToShoe,
	        showingProductModal = _props.showingProductModal,
	        clickOnProductDetails = _props.clickOnProductDetails;
	
	    var isSale = !!sale;
	    var Price = isSale ? 'del' : 'span';
	    var _sale = isSale ? _react2.default.createElement(
	      'span',
	      { className: cx('sale') },
	      '$',
	      sale
	    ) : null;
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: cx('product') },
	        _react2.default.createElement('script', {
	          className: 'gocommerce-product',
	          dangerouslySetInnerHTML: { __html: JSON.stringify(gocommerceData) },
	          type: 'application/json'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: cx('content') },
	          _react2.default.createElement(
	            'div',
	            { className: cx('images') },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', _extends({
	                alt: 'alt is set by content',
	                className: cx('main')
	              }, images[currentImage]))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: cx('thumbnails') },
	              _lodash2.default.map(thumbnails, function (_ref4, side) {
	                var alt = _ref4.alt,
	                    rest = _objectWithoutProperties(_ref4, ['alt']);
	
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    key: side,
	                    onClick: thumbnailHandlers[side],
	                    onKeyDown: thumbnailHandlers[side],
	                    role: 'button',
	                    tabIndex: '0'
	                  },
	                  _react2.default.createElement('img', _extends({ alt: alt }, rest))
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: cx('details') },
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                name
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: cx('price') },
	              _react2.default.createElement(
	                Price,
	                null,
	                '$',
	                prices[0].amount
	              ),
	              ' ',
	              _sale
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: cx('description') },
	              description
	            ),
	            !showingProductModal ? _react2.default.createElement(
	              'ul',
	              { className: cx('list') },
	              details.map(function (detail) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: detail },
	                  _react2.default.createElement(
	                    'small',
	                    null,
	                    detail
	                  )
	                );
	              })
	            ) : _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: '/women/shoes/' + slug,
	                onClick: clickOnProductDetails
	              },
	              'View Full Product Details',
	              ' ',
	              _react2.default.createElement('img', {
	                alt: 'A small right pointing arrow',
	                className: cx('right-arrow'),
	                src: _rightArrow2.default
	              })
	            ),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              'div',
	              { className: cx('sizes') },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Size:'
	              ),
	              ' ',
	              sizes.map(function (value) {
	                return _react2.default.createElement(
	                  'button',
	                  {
	                    className: cx('button-size', currentSize === value ? 'selected' : ''),
	                    key: value,
	                    onClick: sizeHandlers[value]
	                  },
	                  value
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: cx('quantity') },
	              _react2.default.createElement(
	                'div',
	                { className: cx('copy') },
	                'Quantity '
	              ),
	              _react2.default.createElement(_Selector2.default, {
	                className: cx('quantity-selector', 'selector'),
	                maxQuantity: maxQuantity,
	                onChange: quantityChanged,
	                value: currentQuantity
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: cx('submit-content') },
	                isSubmitDisabled ? _react2.default.createElement(
	                  'small',
	                  { className: cx('submit-warning') },
	                  'Please select a size'
	                ) : null,
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: cx('button', isSubmitDisabled ? 'disabled' : ''),
	                    disabled: isSubmitDisabled,
	                    onClick: clickOnAddToCart,
	                    type: 'submit'
	                  },
	                  'Add To Cart'
	                )
	              )
	            )
	          )
	        ),
	        showBackToShoes ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/women/shoes' },
	          _react2.default.createElement(
	            'div',
	            { className: cx('back') },
	            _react2.default.createElement('img', {
	              alt: 'A smal left pointing arrow',
	              className: cx('left-arrow'),
	              src: _leftArrow2.default
	            }),
	            'Back to Shoes'
	          )
	        ) : null
	      ),
	      showBackToShoes && _react2.default.createElement(_FAQ2.default, { type: 'products' })
	    );
	  };
	
	  return Product;
	}(_react.PureComponent);
	
	Product.displayName = 'Product';
	Product.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(Product);

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Product = __webpack_require__(219);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Product).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4yICgzOTA2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+aWNvbnMvc21hbGwtbGVmdC1hcnJvdzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJNYWluLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlJFU09VUkNFUyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUxNC4wMDAwMDAsIC05OS4wMDAwMDApIiBmaWxsPSIjMDAwMDAwIj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9Imljb25zL3NtYWxsLWxlZnQtYXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUyMC4wMDAwMDAsIDEwNS4wMDAwMDApIHNjYWxlKC0xLCAxKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTUyMC4wMDAwMDAsIC0xMDUuMDAwMDAwKSAiIHBvaW50cz0iNTIwIDk5IDUyNiAxMTEgNTE0IDExMSI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"price":"_3SdYWwGzrwqJjgjDdsvJgd","description":"_33vu_0eKDtDCeuYhq492l_","product":"_1spGxdp_cqdIl-WX_Qg9_","content":"_29gXIJGRHN1V9Tk5_M9rd7","images":"_1akgoufiZGuYePnbJzwYG9","main":"_3g3Vh1CaAE7u5b69Yg_P6u","thumbnails":"_2_5_QcIzYXU1bOMJOOqJTA","details":"_3exFQj3eFG4pX5jfpIz3MJ","sale":"_1uP6HUaP_P5nk2pf7PWMFg","list":"_31977YThlr84BTNZfXYr2E","sizes":"_2QkE6H-UybtgwY6zQ2GijN","button-size":"_2VvGc3yuUBR4804l5LjYiQ","selected":"KMIeB0hCeSMiQkpw3t6G6","quantity":"_1XgfQtIWyRv70S1SufP8ku","copy":"_1DXxkbKMz15EAza7pEvHaF","selector":"Mx74YFhA7DyexXAfK_WFt","button":"_3Lm8dZgGjOxF5CrXQOOWd8","disabled":"_1iiqox668rXmiKFuxVovrY","submit-content":"_3qqjnAxsjMxAuuF1yudKQP","submit-warning":"_1M4oi7GdaypuN-fjpBKcRx","back":"u28T_FN1jLiR1iXvmd9jH","left-arrow":"_1lpwH7LNZkFr81WPZ5lZM6","right-arrow":"sguqsX9Rkw8njJZ70fjzP"};

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.currentImageSelector = exports.currentSizeSelector = exports.maxQuantitySelector = exports.currentQuantitySelector = exports.defaultState = exports.clickOnProductDetails = exports.productChanged = exports.productMounted = exports.thumbnailClicked = exports.currentSizeChanged = exports.quantityChanged = exports.clickOnAddToCart = exports.types = exports.ns = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reduxActions = __webpack_require__(100);
	
	var _berkeleysReduxUtils = __webpack_require__(18);
	
	var _redux = __webpack_require__(50);
	
	var _redux2 = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ns = exports.ns = 'product';
	var types = exports.types = (0, _berkeleysReduxUtils.createTypes)(['clickOnAddToCart', 'currentSizeChanged', 'quantityChanged', 'sizeChanged', 'thumbnailClicked', 'productMounted', 'productChanged', 'clickOnProductDetails'], ns);
	
	var clickOnAddToCart = exports.clickOnAddToCart = (0, _reduxActions.createAction)(types.clickOnAddToCart, _lodash2.default.noop, (0, _redux.createCartMeta)());
	var quantityChanged = exports.quantityChanged = (0, _reduxActions.createAction)(types.quantityChanged);
	var currentSizeChanged = exports.currentSizeChanged = (0, _reduxActions.createAction)(types.currentSizeChanged);
	var thumbnailClicked = exports.thumbnailClicked = (0, _reduxActions.createAction)(types.thumbnailClicked);
	var productMounted = exports.productMounted = (0, _reduxActions.createAction)(types.productMounted);
	var productChanged = exports.productChanged = (0, _reduxActions.createAction)(types.productChanged);
	var clickOnProductDetails = exports.clickOnProductDetails = (0, _reduxActions.createAction)(types.clickOnProductDetails);
	
	var defaultState = exports.defaultState = {
	  currentImage: 'front',
	  currentQuantity: 1,
	  currentSize: null
	};
	
	var getNS = function getNS(state) {
	  return state[ns];
	};
	
	var currentQuantitySelector = exports.currentQuantitySelector = function currentQuantitySelector(state) {
	  return getNS(state).currentQuantity;
	};
	var maxQuantitySelector = exports.maxQuantitySelector = function maxQuantitySelector(state) {
	  return getNS(state).maxQuantity;
	};
	var currentSizeSelector = exports.currentSizeSelector = function currentSizeSelector(state) {
	  return getNS(state).currentSize;
	};
	var currentImageSelector = exports.currentImageSelector = function currentImageSelector(state) {
	  return getNS(state).currentImage;
	};
	
	exports.default = (0, _berkeleysReduxUtils.handleActions)(function () {
	  var _ref4;
	
	  return _ref4 = {}, _ref4[(0, _berkeleysReduxUtils.combineActions)(types.quantityChanged, types.productChanged, types.productMounted)] = function (state, _ref) {
	    var payload = _ref.payload;
	    return _extends({}, state, {
	      currentQuantity: payload || 1
	    });
	  }, _ref4[types.currentSizeChanged] = function (state, _ref2) {
	    var payload = _ref2.payload;
	    return _extends({}, state, {
	      currentSize: payload
	    });
	  }, _ref4[types.thumbnailClicked] = function (state, _ref3) {
	    var payload = _ref3.payload;
	    return _extends({}, state, {
	      currentImage: payload || 'front'
	    });
	  }, _ref4[(0, _berkeleysReduxUtils.combineActions)(types.productChanged, _redux2.types.cartUpdate.complete)] = function (state) {
	    return _extends({}, state, {
	      currentQuantity: 1,
	      currentSize: null,
	      currentImage: 'front'
	    });
	  }, _ref4;
	}, defaultState, ns);

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTMgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5UcmlhbmdsZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJSb3V0ZTotL3dvbWVuL3Nob2VzL21vZGFsLVNpemVTZWxlY3RlZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNTguMDAwMDAwLCAtNjAwLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJNb2RhbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzcuMDAwMDAwLCAyNjkuMDAwMDAwKSIgZmlsbD0iIzAwMDAwMCI+CiAgICAgICAgICAgIDxnIGlkPSJUaXRsZS0rLURlc2NyaXB0aW9uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MjAuMDAwMDAwLCA3NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJUcmlhbmdsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY4LjAwMDAwMCwgMjYzLjA3NjEzNSkgcm90YXRlKDkwLjAwMDAwMCkgdHJhbnNsYXRlKC0yNjguMDAwMDAwLCAtMjYzLjA3NjEzNSkgIiBwb2ludHM9IjI2OCAyNTcuMDQwOTk2IDI3NCAyNjkuMTExMjc0IDI2MiAyNjkuMTExMjc0Ij48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.showProductModalSelector = exports.clickOnClosePreview = exports.clickOnProductPreview = exports.types = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _berkeleysReduxUtils = __webpack_require__(18);
	
	var _redux = __webpack_require__(19);
	
	var _redux2 = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ns = 'Products';
	
	var types = exports.types = (0, _berkeleysReduxUtils.createTypes)(['clickOnProductPreview', 'clickOnClosePreview'], ns);
	
	var clickOnProductPreview = exports.clickOnProductPreview = (0, _berkeleysReduxUtils.createAction)(types.clickOnProductPreview);
	var clickOnClosePreview = exports.clickOnClosePreview = (0, _berkeleysReduxUtils.createAction)(types.clickOnClosePreview);
	
	var defaultState = {
	  showProductModal: null
	};
	
	var getNS = function getNS(state) {
	  return state[ns];
	};
	var showProductModalSelector = exports.showProductModalSelector = function showProductModalSelector(state) {
	  return getNS(state).showProductModal;
	};
	
	exports.default = (0, _berkeleysReduxUtils.handleActions)(function () {
	  var _ref2;
	
	  return _ref2 = {}, _ref2[types.clickOnProductPreview] = function (state, _ref) {
	    var name = _ref.payload;
	    return _extends({}, state, {
	      showProductModal: name
	    });
	  }, _ref2[(0, _berkeleysReduxUtils.combineActions)(types.clickOnClosePreview, _redux.types.cartUpdate.complete, _redux2.types.clickOnProductDetails)] = function (state) {
	    console.log('HAI?');
	    return _extends({}, state, {
	      showProductModal: null
	    });
	  }, _ref2;
	}, defaultState, ns);

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Product = __webpack_require__(220);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Product).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productsQuery = exports.productsQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-js-5274fd8a8c4c51e0ebb4.js